import api from '../../baseApi';
import {isDebugging} from '../../../utility';

const cancelStripePort = '/stripe_checkout_cancel';

/**Cancels a Stripe order. */
const cancelStripeAPI = async (userId: string, invoiceId: string, session_id: string) => {
  const res = await api.post(cancelStripePort, {
    userID: userId,
    invoiceID: invoiceId,
    session_id: session_id
  });

  if (isDebugging) {
    console.log(`${cancelStripePort} response:`, res);//TESTING
  }

  return res;
};

export default cancelStripeAPI;